import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, DgSelectionMode, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { firstValueFrom } from 'rxjs';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesDownloadFileService } from 'src/app/core/services/utelize/system/type/types-download-file-service';

const apiPath             =environment.eSimApi+eSimApiPaths.DownloadableFiles;
const exportFilenameSuffix="Downloadable Files-Data";
const popUpTitle          ="Downloadable File";

@Component({
  selector: 'app-downloadable-files-embedded',
  templateUrl: './downloadable-files.component.html',
  styleUrls: ['./downloadable-files.component.scss']
})

export class DownloadableFilesEmbeddedComponent implements AfterViewInit, OnInit {
  
  @Output() gridRowClick   : EventEmitter<number>=new EventEmitter<number>();
  @Output() gridRowDblClick: EventEmitter<number>=new EventEmitter<number>();
  
  @ViewChild('gridView', { static: false }) gridView!: GridViewComponent;
  
  private gridViewDefaults!: GridViewDefaults;
  
  public curUser        : SystemUserDTO;
  public dgApiPath!     : DgApiPath | undefined;
  public dgActionColumn!: DgActionColumn | undefined;
  public dgColumns!     : Array<DgColumn>;
  public dgPopup!       : DgPopup | undefined;
  public dgProperties!  : DgProperties | undefined;
  public gotDgProperties: boolean=false;
  
  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService,
    private typesDownloadFileService  : TypesDownloadFileService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(apiPath);
      this.dgApiPath!.refreshGet=() => this.setUpDgApiPathGet();

      await this.setUpDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPathGet(): Promise<void> {
    try {
      const encResult  =await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>this.curUser.userId, true));
      const userIdEncSS=encResult.result;

      this.dgApiPath!.get=apiPath + "?userIdEncSS=" + userIdEncSS;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn               =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowUpdating=false;
      this.dgActionColumn!.width        =DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup=this.gridViewDefaults.setUpDgPopup(popUpTitle);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      this.dgProperties                 =this.gridViewDefaults.setUpDgProperties("", exportFilenameSuffix);
      this.dgProperties!.encryptDeleteSS=true;
      this.dgProperties!.gridKey        ="EmbeddedDownloadableFiles";
      this.dgProperties!.pageSize       =10;
      this.dgProperties!.selectionMode  =DgSelectionMode.single;
      this.dgProperties!.showAddButton  =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];

      //DownloadFileTypeID
      dgColumn                     =this.gridViewDefaults.setUpDgColumn("downloadFileTypeID", "Category", "", DgColumnDataType.number);
      dgColumn!.dataSource         =this.typesDownloadFileService.idAndDescriptionLookupDataSource();
      dgColumn!.dataSourceForAForm =this.typesDownloadFileService.getIdAndDescription();
      this.dgColumns.push(dgColumn!);

      //Filename
      dgColumn=this.gridViewDefaults.setUpDgColumn("filename", "Document", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //ContentType
      // dgColumn=this.gridViewDefaults.setUpDgColumn("contentType", "Content Type", "", DgColumnDataType.string);
      // this.dgColumns.push(dgColumn!);

      //WebTitle
      dgColumn=this.gridViewDefaults.setUpDgColumn("webTitle", "Web Title", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //WebText
      // dgColumn=this.gridViewDefaults.setUpDgColumn("webText", "Web Text", "", DgColumnDataType.string);
      // this.dgColumns.push(dgColumn!);

      //WebImageFilename
      dgColumn=this.gridViewDefaults.setUpDgColumn("webImageFilename", "Image", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //WebImageFContentType
      // dgColumn=this.gridViewDefaults.setUpDgColumn("webImageFContentType", "Image Content Type", "", DgColumnDataType.string);
      // this.dgColumns.push(dgColumn!);

      //VisualOrder
      dgColumn=this.gridViewDefaults.setUpDgColumn("visualOrder", "Visual Order", "", DgColumnDataType.number);
      this.dgColumns.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public _gridRowClick(rowId: number){
    try {
      this.gridRowClick.emit(rowId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public _gridRowDblClick(rowId: number){
    try {
      this.gridRowDblClick.emit(rowId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
